export const reportCadenceOptions = ["daily", "weekly", "monthly"];

export const formatReportCadenceForDisplay = (
  reportCadence: string | null | undefined
): string => {
  if (reportCadence == null || reportCadence === "") {
    return "Daily";
  }

  return reportCadence.replace(/\b\w/g, (char) => char.toUpperCase());
};

export const reportCadenceLabelToValue = (
  label: string | null | undefined
): string => {
  if (label == null || label === "") {
    return "daily";
  }

  return label.replace(/\b\w/g, (char) => char.toLowerCase());
};
